module.exports = "/_next/static/images/live-chat-b167f057345574b2c466279e10cd6949.svg";